import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Wordmark, ComplianceNote } from "@/components/kit";
import { IMG } from "@/lib/images";
import { toast } from "sonner";

export default function Login() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "demo@stockmybar.com", password: "Demo123!" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      if (mode === "login") await login(form.email, form.password);
      else await register(form.name, form.email, form.password);
      toast.success("Welcome to StockMyBar");
      nav("/");
    } catch (e2) { setErr(apiError(e2.response?.data?.detail) || e2.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={IMG.heroBar} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/50" />
        <div className="absolute bottom-0 p-12 text-white">
          <p className="overline text-primary">For the right ingredients, for the right drinks.</p>
          <h1 className="mt-4 font-display text-5xl leading-tight">The most original<br />gift registry.</h1>
          <p className="mt-4 max-w-md text-white/80">Discover premium drinks, build a bar to your budget, and share exactly what you love with friends and guests.</p>
        </div>
      </div>
      <div className="flex items-center justify-center bg-background p-8">
        <div className="w-full max-w-sm">
          <Link to="/"><Wordmark /></Link>
          <h2 className="mt-8 font-display text-3xl">{mode === "login" ? "Welcome back" : "Create your account"}</h2>
          <p className="mt-1 text-sm text-muted-foreground">You must be 21+ to join StockMyBar.</p>
          <form onSubmit={submit} className="mt-6 space-y-3">
            {mode === "register" && (
              <input data-testid="auth-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Full name" className="w-full rounded-lg border border-border bg-card px-4 py-2.5 outline-none focus:border-primary" />
            )}
            <input data-testid="auth-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Email" className="w-full rounded-lg border border-border bg-card px-4 py-2.5 outline-none focus:border-primary" />
            <input data-testid="auth-password" required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Password" className="w-full rounded-lg border border-border bg-card px-4 py-2.5 outline-none focus:border-primary" />
            {err && <p data-testid="auth-error" className="text-sm text-destructive">{err}</p>}
            <button data-testid="auth-submit" disabled={loading} className="w-full rounded-full bg-primary py-2.5 font-semibold text-primary-foreground disabled:opacity-60">
              {loading ? "Please wait…" : mode === "login" ? "Sign in" : "Create account"}
            </button>
          </form>
          <p className="mt-4 text-sm text-muted-foreground">
            {mode === "login" ? "New here? " : "Have an account? "}
            <button data-testid="auth-toggle" onClick={() => setMode(mode === "login" ? "register" : "login")} className="font-semibold text-primary hover-underline">
              {mode === "login" ? "Create an account" : "Sign in"}
            </button>
          </p>
          <div className="mt-6 rounded-lg border border-border bg-muted/40 p-3 text-xs">
            <p className="font-semibold">Demo login</p>
            <p className="text-muted-foreground">demo@stockmybar.com · Demo123!</p>
          </div>
          <div className="mt-6"><ComplianceNote /></div>
        </div>
      </div>
    </div>
  );
}
